import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import WidgetContextMenuActionFilter from './WidgetContextMenuActionFilter';
import WidgetContextMenuActionLink from './WidgetContextMenuActionLink';
import brockMuiTheme from '../../../shared/constants/brockMuiTheme';
import { widgetContextMenuActionTypes } from '../../../shared/constants/constants';

export default function WidgetContextMenu(props) {
    function getMenuItems() {
        return props.actions.map((action) => {
            const dataItem = props.contextMenuData.data[action.dataKey];

            switch (action.type) {
                case widgetContextMenuActionTypes.filter:
                    return (
                        <WidgetContextMenuActionFilter
                            action={action}
                            availableFilters={props.availableFilters}
                            dataItem={dataItem}
                            filterName={props.legendFormatter(dataItem.name)}
                            handleWidgetMenuFilter={
                                props.handleWidgetMenuFilter
                            }
                            onClose={props.onClose}
                        />
                    );
                case widgetContextMenuActionTypes.link:
                    return (
                        <WidgetContextMenuActionLink
                            action={action}
                            dataItem={dataItem}
                            metricRequest={props.contextMenuData.metricRequest}
                            onClose={props.onClose}
                            openLinksInNewTab={props.openLinksInNewTab}
                        />
                    );
                default:
                    return null;
            }
        });
    }

    if (!props.contextMenuData) {
        return null;
    }

    return (
        <MuiThemeProvider theme={brockMuiTheme}>
            <Menu
                getContentAnchorEl={null}
                anchorOrigin={{ horizontal: 'center', vertical: 'center' }}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorEl={props.contextMenuData.currentTarget}
                onClose={props.onClose}
                open={props.isOpen}
            >
                {getMenuItems()}
            </Menu>
        </MuiThemeProvider>
    );
}

WidgetContextMenu.propTypes = {
    actions: PropTypes.instanceOf(Object),
    availableFilters: PropTypes.instanceOf(Object),
    contextMenuData: PropTypes.instanceOf(Object),
    handleWidgetMenuFilter: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    legendFormatter: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    openLinksInNewTab: PropTypes.bool.isRequired,
};
